import script from "./EulaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EulaView.vue?vue&type=script&setup=true&lang=ts"

import "./EulaView.vue?vue&type=style&index=0&id=69e20d9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e20d9b"]])

export default __exports__